module.exports = __webpack_public_path__ + "media/application/images/icons/confidence-level-1-818151d21dac34f1c54fbad7bd78f018.svg";